import React, { Component } from 'react';
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";
import axios from "axios";
import { useLocation } from 'react-router-dom'
import {BeatLoader} from 'react-spinners';
import {css} from "@emotion/core";
const { tableau } = window;
class TableauEmbed2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //viz:null,
            tableau_worksheet:[],
            project_name:"",
            loading: true,
            underlyingData: null,
        }
    }
  componentDidMount() {
   //this.initTableauViz()
     const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log(decoded);

        this.get_trusted_token(decoded.tableau_username);

  }
  get_trusted_token(tableau_username){
        if(tableau_username==='' || tableau_username===null || tableau_username==='null'){
            alert("Your account is not mapped with tableau user.");
            this.setState({
               loading:false,
            });
            return false;
        }

        axios.get(config.get('API_URL')+'/tableau/get-trusted-token/',

       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                tableau_username: tableau_username,
            }
        }).then(response => {
            //console.log(response.data);

            if(response.data.data!== undefined) {
                this.get_tableau_report(this.props.match.params.id);

                this.setState({
                    tableau_token:response.data.data,
                    tableau_server_url: response.data.server_url,
                    token_error:false,
                    loading:false,
                });
            } else {
                alert("Error while generating token");
                //this.get_tableau_report(this.props.match.params.id);
                //console.log("dddddddd", response.data.error.error)
                this.setState({
                    token_error:true,
                    loading:false,
                    tableau_token:response.data.data,
                    tableau_server_url: response.data.server_url

                });
            }


        }).catch(error => {
          console.log(error);
        });
    }
    get_tableau_report(view_id){
         axios.post(config.get('API_URL')+'/tableau/get-tableau-report/',
         {
            view_id:view_id
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            this.setState({
                tableau_report_name: response.data.view_name,
                tableau_report_link: response.data.url,
                workbook_name: response.data.project_name,
                workbook_kpi_id: response.data.project_id,
                worksheet_name: response.data.workbook_name,
                worksheet_kpi_id: response.data.workbook_id,
            })
            this.initTableauViz()
        }).catch( err => {
            console.log(err);
        });
    }


  initTableauViz = () => {
    let reportUrl = this.state.tableau_server_url+"/trusted/"+this.state.tableau_token+this.state.tableau_report_link
    const vizDiv = document.getElementById('tableauViz');
    const vizURL = reportUrl;

    const options = {
      width: '1200px',
      height: '800px',
      hideTabs: false,
      hideToolbar: false,
    };

    // Create a new Tableau Viz object
    const viz = new tableau.Viz(vizDiv, vizURL, options);
    this.viz = viz;
  };
  exportToPDF(viz) {
    if (this.viz) {
      this.viz.showExportPDFDialog();
    }
  }
  exportToCSV() {
    // Call the showExportCrossTabDialog method on the viz object
    if (this.viz) {
      this.viz.showExportCrossTabDialog();
    }
  }
  showDownloadDialog() {
    // Call the showExportCrossTabDialog method on the viz object
    if (this.viz) {
      this.viz.showDownloadDialog();
    }
  }
  exportData() {
    // Call the showExportCrossTabDialog method on the viz object
    if (this.viz) {
      this.viz.showExportDataDialog();
    }
  }
  getUnderlyingData() {
    // Call the getUnderlyingDataAsync method on the viz object
    if (this.viz) {
         var sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets().get("Source-Destination");
	       // If the active sheet is not a dashboard, then you can just enter:
	       // viz.getWorkbook().getActiveSheet();
         var options = {
            maxRows: 0, // Max rows to return. Use 0 to return all rows
            ignoreAliases: false,
            ignoreSelection: false,
            includeAllColumns: true
          };
          console.log(sheet);
          if(sheet) {
             console.log("find the sheet")
          }
          else {
              console.log("worksheet data null")
          }
          sheet.getUnderlyingDataAsync(options).then(function(t){
                       var table = t.getData();
                       console.log(table);

                });
//       this.viz.getUnderlyingDataAsync().then((t) => {
//         // The promise resolves with the Tableau data object
//         const worksheetData = t.getWorksheet('Storm Map Sheet'); // Replace 'Sheet1' with the desired sheet name
//         const data = worksheetData.getData();
//
//         // The data object contains rows, columns, and the underlying data
//         this.setState({ underlyingData: data });
//         console.log(data)
//       });
    }
  }
  render() {
    return (
      <div>
        {/* The container for the Tableau visualization */}
        <button onClick={() => this.exportToPDF()}>Export PDF</button>
        <button onClick={() => this.exportToCSV()}>Export CSV</button>
        <button onClick={() => this.exportData()}>Export Data</button>
        <button onClick={() => this.showDownloadDialog()}>Show Download Dialog</button>

        <div id="tableauViz"></div>
         <button onClick={() => this.getUnderlyingData()}>Get Underlying Data</button>
      </div>
    );
  }
}

export default TableauEmbed2;